import { Redirect, navigate } from '@reach/router';
import React, { Suspense } from 'react';

import MainLayout from '../components/MainLayout';

import { navigations } from '../config/constants';

import { useStateValue } from '../state';

export default ({ method }) => {
  const ButtonMethod = React.lazy(() => import('../components/ButtonMethod'));
  const [, dispatch] = useStateValue();
  const methodsArray = navigations.find(navigation => navigation.key === method).methods;
  const navigationsArray = navigations.map(navigation => navigation.key);
  const goBack = () => navigate('/');

  if (!navigationsArray.includes(method)) {
    return <Redirect to="/" noThrow />;
  }

  React.useEffect(() => {
    dispatch({
      type: 'CUP_SET',
      payload: {
        count: 1,
      },
    });
  }, [dispatch]);

  return (
    <MainLayout>
      <div className="page--header">
        <img
          alt=""
          className="img--close"
          src="/images/back-button.svg"
          onClick={goBack}
        />
        <div className="page--header-method">
          <h3 className="page--header-method-title">Select Brew Method</h3>
          <p className="page--header-method-sub">
            How would you like to best brew your coffee beans?
          </p>
        </div>
      </div>
      <div className="page--body">
        <div className="page--body-method">
            {methodsArray.map(method => (
              <Suspense fallback={null} key={method.key}>
                <div className="page--body-method--container">
                  <ButtonMethod method={method} />
                  </div>
              </Suspense>
            ))}
        </div>
      </div>
    </MainLayout>
  );
}
